import type { Docente, CreateDocenteCommand, UpdateDocenteCommand, DocenteAssignment, CreateDocenteAssignmentCommand } from '@/domain/model/Docente';
import type { Page } from '@/domain/model/Page';
import type { DocenteGateway } from '@/application/port/out/DocenteGateway';
import type {
  ListDocentesUseCase, ListDocentesParams, GetDocenteUseCase, CreateDocenteUseCase,
  UpdateDocenteUseCase, ArchiveDocenteUseCase,
  ListDocenteAssignmentsUseCase, AssignDocenteUseCase, UnassignDocenteUseCase,
} from '@/application/port/in/DocenteUseCase';

export class ListDocentes implements ListDocentesUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(p: ListDocentesParams): Promise<Page<Docente>> { return this.g.list(p); }
}
export class GetDocente implements GetDocenteUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(id: string): Promise<Docente> { return this.g.get(id); }
}
export class CreateDocente implements CreateDocenteUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(c: CreateDocenteCommand): Promise<Docente> { return this.g.create(c); }
}
export class UpdateDocente implements UpdateDocenteUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(id: string, c: UpdateDocenteCommand): Promise<Docente> { return this.g.update(id, c); }
}
export class ArchiveDocente implements ArchiveDocenteUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(id: string): Promise<Docente> { return this.g.archive(id); }
}
export class ListDocenteAssignments implements ListDocenteAssignmentsUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(docenteId: string): Promise<DocenteAssignment[]> { return this.g.listAssignments(docenteId); }
}
export class AssignDocente implements AssignDocenteUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(docenteId: string, c: CreateDocenteAssignmentCommand): Promise<DocenteAssignment> {
    return this.g.assign(docenteId, c);
  }
}
export class UnassignDocente implements UnassignDocenteUseCase {
  constructor(private readonly g: DocenteGateway) {}
  execute(docenteId: string, assignmentId: string): Promise<void> {
    return this.g.unassign(docenteId, assignmentId);
  }
}
